import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import loader from "../assets/loader.gif";
import { ToastContainer, toast } from "react-toastify";
import { setAvatarRoute } from "../utils/API_Routes.js";

import "react-toastify/dist/ReactToastify.css";
import useImageFetch from "../hooks/useImageFetch";
import useAxiosPrivate from '../hooks/usePrivateRoute'
import { useDispatch, useSelector } from "react-redux";
import { removeUser, setUser } from "../features/user/userSlice";

const SetAvatar = () => {
  const api = 'https://api.multiavatar.com/45678945';
  const { user } = useSelector((state) => state.user)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const privateRoute = useAxiosPrivate();
  const [selectedAvatar, setSelectedAvatar] = useState(undefined);
  const { avatars, isLoading } = useImageFetch(api);

  useEffect(() => {
    if (!user) {
      navigate('/login')
      return;
    }
    if (user.isAvatarImageSet) {
      navigate('/')
    }

  }, [navigate, user])

  const toastCreator = (message) => {
    const toastOptions = {
      position: 'bottom-right',
      autoClose: 8000,
      pauseOnHover: true,
      draggable: true,
      theme: 'dark'
    }
    toast.error(message, toastOptions);
    return false;
  }

  const setProfilePicture = async () => {
    if (selectedAvatar === undefined) {
      toastCreator('please select an avatar');
      return;
    }
    const { data } = await privateRoute.post(`${setAvatarRoute}/${user._id}`, {
      from: user._id,
      image: avatars[selectedAvatar]
    }
    ).catch(error => {
      navigate('/login', { state: { from: location }, replace: true });
      dispatch(removeUser())
    })
    if (data.isSet) {
      dispatch(setUser({ ...user, isAvatarImageSet: true, avatarImage: data.image }))
      navigate('/');
    } else {
      toastCreator("Error setting avatar image. Please try again later")
    }
  }
  if (isLoading) {
    return <Wrapper>
      <img className="loader" src={loader} alt="loader" />
    </Wrapper>
  }
  return (
    <>
      <Wrapper>
        <div className="title-container">
          <h1>Pick an avatar as your profile picture</h1>
        </div>
        <div className="avatars">{
          avatars.map((avatar, i) => {
            return (
              <div className={
                `avatar ${selectedAvatar === i ? 'selected' : ""
                }`
              } key={i}
              >
                <img src={`data:image/svg+xml;base64,${avatar}`} alt="avatar" onClick={() => setSelectedAvatar(i)} />
              </div>
            )
          })
        }</div>
        <button className="submit-btn" onClick={setProfilePicture}>Set as Profile Picture</button>
      </Wrapper>
      <ToastContainer />
    </>
  )
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 3rem;
  background-color: #131324;
  height: 100vh;
  width: 100vw;
  .loader {
    max-inline-size: 100%;
  }
  .title-container {
    h1 {
      color: white;
    }
  }
  .avatars {
    display: flex;
    gap: 2rem;
    .avatar {
      border: 0.4rem solid transparent;
      padding: 0.4rem;
      border-radius: 5rem;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: 0.5s ease-in-out;
      img {
        height: 6rem;
        transition: 0.5s ease-in-out;
      }
    }
    .selected {
      border: 0.4rem solid #4e0eff;
    }
  }
  .submit-btn {
    background-color: #4e0eff;
    color: white;
    padding: 1rem 2rem;
    border: none;
    font-weight: bold;
    cursor: pointer;
    border-radius: 0.4rem;
    font-size: 1rem;
    text-transform: uppercase;
    &:hover {
      background-color: #4e0eff;
    }
  }
`

export default SetAvatar